import mori from 'mori';
import { indexOf } from '../../util/util';

/**
 * Get the active footnotes
 * @param  {mori.vector} footnotes     [footnotes from sheetData]
 * @param  {mori.vector} timeframes    [active timeframes]
 * @param  {mori.vector} locations     [active locations]
 * @param  {mori.vector} distributions [active distributions]
 * @return {mori.vector}               [active footnotes]
 */
export default function getActiveFootnotes(
  footnotes,
  timeframes,
  locations,
  distributions
) {
  return mori.reduceKV(
    (acc, key, val) => mori.merge(acc, val),
    mori.hashMap(),
    mori.reduce(
      (acc0, item0) => mori.assoc(acc0, mori.first(item0), mori.reduce(
        (acc1, item1) => mori.assoc(acc1, mori.first(item1), mori.last(item1)),
        mori.hashMap(),
        mori.last(item0)
      )),
      mori.hashMap(),
      mori.filter(
        (item) => indexOf(timeframes, mori.first(item)),
        mori.reduce(
          (acc0, curr0) => mori.conj(acc0, mori.vector(
            mori.first(curr0),
            mori.filter(
              (item) => (locations) ?
                indexOf(
                  locations,
                  mori.first(item).replace(/(.*?)\[.*\]/, (match, p1) => p1)
                ) :
                true,
              mori.zipmap(
                mori.map(
                  (key) => key.replace(/(.*?)\[.*\]/, (match, p1) => p1),
                  mori.keys(mori.last(curr0))
                ),
                mori.map((item) =>
                  mori.reduceKV(
                    (acc1, key, curr1) => !!indexOf(distributions, key) ?
                      mori.assoc(acc1, key, curr1) :
                      acc1,
                    mori.hashMap(),
                    item
                  ),
                  mori.vals(mori.last(curr0))
                )
              )
            )
          )),
          mori.vector(),
          footnotes
        )
      )
    )
  );
}



// WEBPACK FOOTER //
// ../~/eslint-loader!./js/services/getFootnotes/getActiveFootnotes.js